import create from 'zustand';
import shallow from 'zustand/shallow';

import { SubItem } from '../types/sub-item.types';

type ActionState = {
   partsToCopy: SubItem[];
   familyName?: string;
};

export const copyState = create<ActionState>(() => ({
   partsToCopy: [],
   familyName: undefined,
}));

export const copyParts = (parts: SubItem[], familyName?: string) => {
   const clientCreatedParts = parts.filter((part) => part.clientCreated);
   copyState.setState({
      partsToCopy: clientCreatedParts,
      familyName: clientCreatedParts.length > 0 ? familyName : undefined,
   });
};

export const clearCopiedParts = () => {
   copyState.setState({ partsToCopy: [], familyName: undefined });
};

export const useCopyParts = () => {
   const [copiedParts, familyName] = copyState((s) => [s.partsToCopy, s.familyName], shallow);

   return {
      copiedParts,
      hasCopiedParts: copiedParts.length > 0,
      familyName,
      copyParts,
      clearCopiedParts,
   };
};
